<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-title>Main Menu</ion-title>
        <ion-buttons slot="start">
          <ion-back-button href="/"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-grid>
        <ion-row justify-content-center>
          <ion-col align-self-center size="12" size-sm>
            <div>
              <ion-button
                size="default"
                class="adjust-font-size"
                @click="changePassword()"
                expand="block"
              >Change Password</ion-button>
            </div>
            <div>
              <ion-button
                size="default"
                id="createPatientAppointment"
                class="adjust-font-size"
                @click="makeAppointments"
                expand="block"
              >Book Appointments</ion-button>
            </div>
            <div>
              <ion-button
                size="default"
                class="adjust-font-size"
                @click="cancelAppointments"
                expand="block"
              >Cancel Shot Appointments</ion-button>
            </div>
            <div>
              <ion-button
                size="default"
                class="adjust-font-size"
                @click="viewExistingAppointments"
                expand="block"
              >View Existing Shot Appointments</ion-button>
            </div>
            <div >
              <ion-button
                size="default"
                class="adjust-font-size"
                @click="addFamilyAccount"
                expand="block"
              >Add Family Accounts</ion-button>
            </div>
            <div>
              <ion-button
                size="default"
                class="adjust-font-size"
                @click="viewFamilyAccount"
                expand="block"
              >View Family Accounts</ion-button>
            </div>
            <div>
              <ion-button
                size="default"
                class="adjust-font-size"
                @click="logout"
                expand="block"
              >Log Out</ion-button>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
    <div id="app">
      <modal v-show="isModalVisible" @close="closeModal" />
    </div>
  </div>
</template>
<script>
import modal from "../../components/modal/modal.vue";
import Repository from "../../repositories/RepositoryFactory";
var AuthorizationRepository = Repository.get("authorization");
var BroadcastRepository = Repository.get("broadcast");

export default {
  components: {
    modal
  },
  name: "adminmainpage",
  data() {
    return {
      isModalVisible: false,
      broadcastMessage: ""
    };
  },
  created: async function() {
    var result = await BroadcastRepository.getBroadcastMessage(
      this.$route.params.data + "~" + this.$store.state.location
    );
    // eslint-disable-next-line no-console
    console.log(result);

    var i;
    for (i = 0; i < result.data.length; i++) {
      this.broadcastMessage =
        this.broadcastMessage + result.data[i].message + " ";
    }
    if (result.data.length > 0) {
      this.$store.state.messageBody = this.broadcastMessage;
      this.isModalVisible = true;
    }
  },
  methods: {
    changePassword() {
      let self = this;
      self.$router.push({ name: "changepassword" });
    },
    addUpdateShotPatients() {
      let self = this;
      self.$router.push({ name: "addupdateshotpatients" });
    },
    makeAppointments() {
      let self = this;
      self.$router.push({ name: "makeappointments" });
    },
    cancelAppointments() {
      let self = this;
      self.$router.push({ name: "cancelappointments" });
    },
    viewExistingAppointments() {
      let self = this;
      self.$router.push({ name: "viewexistingappointments" });
    },
    addFamilyAccount() {
      let self = this;
      self.$router.push({ name: "addpatientsscreentwo" });
    },
    viewFamilyAccount() {
      let self = this;
      self.$router.push({ name: "otherpatientsscreenone" });
    },
    logout: async function() {
      var result = await AuthorizationRepository.adminlogout();
      if (result.data.status === "Success") {
        let self = this;
        self.$router.push({ name: "home" });
      } else {
        alert("Logout Failed");
      }
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    }
  }
};
</script>
